<template>
  <div>

    <button @click="toggleCollapse" class="tag-listing-filters-btn">
      <span class="tag-listing-filters-group-name">{{ group.tagGroupName }}</span>
      <em :class="[{ 'ti-minus': collapsed, 'ti-plus': !collapsed }]"></em>
    </button>
    <div
      class="tag-listing-filters-tag-entries"
      :class="getTagEntriesClassName"
    >
      <div v-if="collapsed" :class="[{ 'collapsed': collapsed }]">
        <EntryFilter
          v-for="tagEntry in entries"
          :key="tagEntry.id"
          :entry="tagEntry"
          :group="group"
          class="tag-listing-filters-tag-entry"
        >
        </EntryFilter>
      </div>
    </div>
  </div>
</template>

<script>

import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  data () {
    return {
      collapsed: false
    }
  },
  props: {
    group: {
      tagDisplayType: '',
      tagGroupId: '',
      tagGroupName: null,
      tagGroupStep: 0,
      tagGroupDisplayPosition: 0,
      tags: []
    },
    entries: {
      type: Array
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getTagEntriesClassName () {
      let className = ''
      className += this.group.tagDisplayType
      return className
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    }
  }
}
</script>
